/**
 * @author        yontaek@zumper.com (Yon Taek Chung)
 * @copyright     Copyright (c) 2022, Zumper
 * @description   guessMapDimensions
 */

import { ON_SERVER } from '@zcode/nr/es/shared/env'
import type { selectMapDimensions } from '../module/map/selectors'

const HEADER_HEIGHT = 134 // includes filter bar
const MOBILE_HEADER_HEIGHT = 174
const VIEWPORT_OFFSET = 2

export const getDimensionsFromViewport = (
  viewport: {
    height: number
    width: number
  },
  isFullWidthMap?: boolean
) => {
  if (!viewport?.height || !viewport.width) {
    return viewport || { height: null, width: null }
  }

  if (viewport.width < 768) {
    return {
      height: viewport.height - MOBILE_HEADER_HEIGHT,
      width: viewport.width,
    }
  }

  if (viewport.width < 992) {
    return {
      height: viewport.height - HEADER_HEIGHT,
      width: isFullWidthMap
        ? viewport.width - VIEWPORT_OFFSET
        : viewport.width / 2 - VIEWPORT_OFFSET,
    }
  }

  let railWidth = isFullWidthMap ? 0 : 1103

  if (viewport.width >= 1280 && viewport.width < 1440) {
    railWidth = isFullWidthMap ? 0 : viewport.width / 2
  } else if (viewport.width < 1280) {
    railWidth = isFullWidthMap ? 0 : 670
  }

  return {
    height: viewport.height - HEADER_HEIGHT - VIEWPORT_OFFSET,
    width: viewport.width - railWidth - VIEWPORT_OFFSET,
  }
}

export const guessMapDimensions = (
  mapSize: ReturnType<typeof selectMapDimensions>,
  isFullWidthMap?: boolean
) => {
  if (mapSize?.height && mapSize?.width) {
    return mapSize
  }
  if (ON_SERVER || typeof document === 'undefined') {
    return mapSize || { height: null, width: null }
  }

  // otherwise, measure the viewport
  const viewport = {
    height: document.documentElement.clientHeight || document.body.clientHeight,
    width: document.documentElement.clientWidth || document.body.clientWidth,
  }
  return getDimensionsFromViewport(viewport, isFullWidthMap)
}
